document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll(
    'form[data-type="add-to-cart-form"]'
  );

  const valueOf = (form, names) => {
    for (const name of names) {
      const field = form.querySelector(`[name="properties[${name}]"]`);
      if (field && field.value) return field.value;
    }
    return '';
  };

  const codeAfterDash = value => {
    if (!value) return '';
    const parts = value.split('- ');
    return parts.length > 1 ? parts[1].split(' ')[0] : '';
  };

  const makeSku = form => {
    const output = form.querySelector('.cat-generated-sku');
    if (!output) return;

    const baseSku = output.dataset.baseSku || '';

    let length = valueOf(form, ['Length']);
    if (length) {
      const parts = length.trim().split(/\s+/);
      if (parts[1] === 'in') length = `S${parts[0]}`;
      else if (parts[1] === 'cm') length = parts[0];
    }

    const sections = valueOf(form, [
      'Sections',
      'Sections 1',
      'Sections 2',
      'Sections 3',
      'Sections 4',
      'Sections 5',
      'Sections 6'
    ]);

    const tip = codeAfterDash(valueOf(form, ['Tip']));

    const tipColor = codeAfterDash(valueOf(form, [
      'Tip Color',
      'Tip Color 1',
      'Tip Color 2',
      'Tip Color 3',
      'Tip Color 4',
      'Tip Color 5',
      'Tip Color 6'
    ]));

    const hiLite = codeAfterDash(valueOf(form, [
      'HiLite Color',
      'HiLite Color 1',
      'HiLite Color 2',
      'HiLite Color 3',
      'HiLite Color 4',
      'HiLite Color 5',
      'HiLite Color 6'
    ]));

    const shaftColor = codeAfterDash(
      valueOf(form, ['Shaft Color'])
    );

    const mainShaftColor = codeAfterDash(
      valueOf(form, ['Main shaft color'])
    );

    const bottomShaftColor = codeAfterDash(
      valueOf(form, ['Bottom shaft color'])
    );

    const mainShaft = codeAfterDash(
      valueOf(form, ['Main Shaft'])
    );

    const bottomShaft = codeAfterDash(
      valueOf(form, ['Bottom Shaft'])
    );

    output.value =
      baseSku +
      shaftColor +
      mainShaftColor +
      bottomShaftColor +
      tip +
      tipColor +
      hiLite +
      '-' +
      length +
      '-' +
      sections +
      mainShaft +
      bottomShaft;
  };

  forms.forEach(form => {
    if (!form.querySelector('.cat-generated-sku')) return;

    form.addEventListener('change', () => makeSku(form));

    form.addEventListener('submit', () => {
      makeSku(form);
    });

    setTimeout(() => makeSku(form), 1500);
  });
});